'use client';

import { Carousel } from '@soluto-private/aui-react-carousel';
import { useEffect, useState } from 'react';

export * from '@soluto-private/aui-react-carousel';

export function AuiCarousel(props: any) {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return isClient ? <Carousel {...props} /> : null;
}
